var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9149 7.19173H10.0815V10.8584H6.41488V12.6917H10.0815V16.3584H11.9149V12.6917H15.5815V10.8584H11.9149V7.19173ZM10.9982 2.6084C5.93821 2.6084 1.83154 6.71507 1.83154 11.7751C1.83154 16.8351 5.93821 20.9417 10.9982 20.9417C16.0582 20.9417 20.1649 16.8351 20.1649 11.7751C20.1649 6.71507 16.0582 2.6084 10.9982 2.6084ZM10.9982 19.1084C6.95571 19.1084 3.66488 15.8176 3.66488 11.7751C3.66488 7.73257 6.95571 4.44173 10.9982 4.44173C15.0407 4.44173 18.3315 7.73257 18.3315 11.7751C18.3315 15.8176 15.0407 19.1084 10.9982 19.1084Z",
    fill: "#1890FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.1cddb3ba480224db27058aea9faa241f.svg";
export { ForwardRef as ReactComponent };